// Sdílený feedback toast (#224) — hlášky pro AJAX akce, které default Shoptet
// JS nechává němé (neplatný kupón, strop množství, potvrzení hlídání ceny).
// Vizuální řeč .bs-cart-toast (tmavý fixed toast vpravo dole): jeden uzel,
// nová hláška předchozí nahradí, chyba drží déle a hlásí se jako role=alert.
// Kdo hlášky vyrábí, je ajaxFeedback.js — tenhle modul jen kreslí.

import { icon } from './icon.js';

const HIDE_MS = { success: 4000, error: 8000 };

let host = null;
let hideTimer = null;

function ensure() {
  if (host && document.body.contains(host)) return host;
  host = document.createElement('div');
  host.className = 'bs-fb-toast';
  document.body.appendChild(host);
  return host;
}

export function showFeedback(text, kind) {
  if (!text) return;
  const type = kind === 'error' ? 'error' : 'success';
  const el = ensure();
  el.classList.toggle('bs-fb-toast--error', type === 'error');
  // chybu má čtečka ohlásit hned, potvrzení stačí zdvořile
  el.setAttribute('role', type === 'error' ? 'alert' : 'status');
  el.textContent = '';
  el.appendChild(icon(type === 'error' ? 'info' : 'check', 'bs-fb-toast__icon'));
  const span = document.createElement('span');
  span.className = 'bs-fb-toast__text';
  span.textContent = text;
  el.appendChild(span);

  el.classList.add('is-visible');
  clearTimeout(hideTimer);
  hideTimer = setTimeout(function () {
    el.classList.remove('is-visible');
  }, HIDE_MS[type]);
}
